const LOADING = "LOADING";
const SET_MESSAGE = "SET_MESSAGE";
const CLEAR_MESSAGE = "CLEAR_MESSAGE";
const WEBSITE_URL = "WEBSITE_URL";
const PID = "PID";
const TITLE = "TITLE";
const BACKGROUNDCOLOR = "BACKGROUNDCOLOR"
const TEXTCOLOR = "TEXTCOLOR"
const WEBSITE_SCANNING_PROCESS = "WEBSITE_SCANNING_PROCESS";
const WEBSITE_SCANNING_PROCESS_PER = "WEBSITE_SCANNING_PROCESS_PER";
const WEBSITE_SCANNING_PROCESS_PER_RESET = "WEBSITE_SCANNING_PROCESS_PER_RESET";
const WEBSITE_RESCANNING_PROCESS = "WEBSITE_RESCANNING_PROCESS";
const IS_FROM_SCRIPT = "IS_FROM_SCRIPT";
const SET_TOKEN = "SET_TOKEN";
const WEBSITE_SCREENSHOT = "WEBSITE_SCREENSHOT";
const WEBSITE_WIDGET = "WEBSITE_WIDGET";
const SET_PAID = "SET_PAID";
const SET_STANDARD = "SET_STANDARD";
const SET_LEVEL_FAIL_COUNT = "SET_LEVEL_FAIL_COUNT";
const SET_LEVEL_FAIL_COUNT_FIXED_BY_WIDGET = "SET_LEVEL_FAIL_COUNT_FIXED_BY_WIDGET";
const SET_FORM_SUBMIT_FLAG = "SET_FORM_SUBMIT_FLAG";
const SET_LANGUAGE = "SET_LANGUAGE";
const PID_API_LOADING = "PID_API_LOADING";

export {
    LOADING,
    SET_MESSAGE,
    CLEAR_MESSAGE,
    WEBSITE_URL,
    PID,
    TITLE,
    BACKGROUNDCOLOR,
    TEXTCOLOR,
    WEBSITE_SCANNING_PROCESS,
    WEBSITE_SCANNING_PROCESS_PER,
    WEBSITE_SCANNING_PROCESS_PER_RESET,
    WEBSITE_RESCANNING_PROCESS,
    IS_FROM_SCRIPT,
    WEBSITE_SCREENSHOT,
    WEBSITE_WIDGET,
    SET_STANDARD,
    SET_TOKEN,
    SET_PAID,
    SET_LEVEL_FAIL_COUNT,
    SET_LEVEL_FAIL_COUNT_FIXED_BY_WIDGET,
    SET_FORM_SUBMIT_FLAG,
    SET_LANGUAGE,
    PID_API_LOADING
};